// extracted by mini-css-extract-plugin
module.exports = {"noteTabs":"style-module__noteTabs___xbO_m","notes":"style-module__notes___1mw0y","notesColumn":"style-module__notesColumn___F8UuM","note":"style-module__note___1JB3s"};